import { render, staticRenderFns } from "./FromCascader.vue?vue&type=template&id=4ef42ab3&scoped=true"
import script from "./FromCascader.vue?vue&type=script&lang=js"
export * from "./FromCascader.vue?vue&type=script&lang=js"
import style0 from "./FromCascader.vue?vue&type=style&index=0&id=4ef42ab3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef42ab3",
  null
  
)

export default component.exports